import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_172: DocMigration = {
  maxSchemaVersion: "0.0.172",
  description: "Remove EXTERIOR_SCREENED roomEnclosure and replace with hasExteriorTrim roomAttribute",

  apply(json: any) {
    if (json.rooms) {
      for (const id in json.rooms) {
        const room = json.rooms[id];

        if (
          room.attributes?.roomEnclosure === "EXTERIOR" ||
          room.attributes?.roomEnclosure === "CONDITIONED" ||
          room.attributes?.roomEnclosure === "UNCONDITIONED"
        ) {
          room.attributes["hasExteriorTrim"] = true;
        }

        if (room.attributes?.roomEnclosure === "EXTERIOR_SCREENED") {
          room.attributes.roomEnclosure = "EXTERIOR";
          room.attributes["hasExteriorTrim"] = false;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_172;
